export default function FormNotice({ children, tone = "warning" }) {
  if (!children) {
    return null;
  }

  return (
    <div className={`form-notice ${tone}`} role={tone === "error" ? "alert" : "status"}>
      {children}
    </div>
  );
}
